/** saves Cards List
@payload { Array }
*/
export const SAVE_CARDS_LIST = (state, payload) => {
	state.cardsList = payload.map(card => {
		return {
			...card,
			friendlyName: card.additionalInfoCardView.friendlyName ? card.additionalInfoCardView.friendlyName : ''
		}
	})
}

/** saves Accounts Balances
@payload { Array }
*/
export const SAVE_ACCOUNTS_BALANCES = (state, payload) => {
	state.accountsBalances = payload.balanceViews
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
	state.cardsList = []
	state.accountsBalances = []
}
